import { isNil } from 'ramda'
import { FormattedMessage } from 'react-intl'
import { CHANNEL_APP } from 'app/constants/channel'
import { channelsList } from 'app/constants/messageDetail'

export const channelName = (channel, appName) => {
  if (isNil(channel)) return
  if (channel === CHANNEL_APP) {
    return (
      <FormattedMessage id={channelsList[channel].name} values={{ appName }} />
    )
  } else return <FormattedMessage id={channelsList[channel].name} />
}
